<template>
  <div>
    <div ref="activationReportChart" style="min-height: 400px"></div>
  </div>
</template>

<script>
/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import moment from "moment";

export default {
  data() {
    return {
      chart: null,
      dummyData: [
        {
          period: "January",
          activated: this.randomInt(100, 500),
          deactivated: this.randomInt(50, 100),
        },
        {
          period: "February",
          activated: this.randomInt(100, 500),
          deactivated: this.randomInt(50, 100),
        },
        {
          period: "March",
          activated: this.randomInt(100, 500),
          deactivated: this.randomInt(50, 100),
        },
        {
          period: "April",
          activated: this.randomInt(100, 500),
          deactivated: this.randomInt(50, 100),
        },
        {
          period: "May",
          activated: this.randomInt(100, 500),
          deactivated: this.randomInt(50, 100),
        },
        {
          period: "June",
          activated: this.randomInt(100, 500),
          deactivated: this.randomInt(50, 100),
        },
      ],
    };
  },
  props: ["data", "filter"],
  mounted() {
    this.createChart();
    this.getData();
  },
  watch: {
    data: {
      deep: true,
      handler: "getData",
    },
  },
  methods: {
    getData() {
      let length = this.chart.data.length;
      let filter = this.filter.filter;
      let data = JSON.parse(JSON.stringify(this.data));
      let indoMonthNames = [
        "Januari",
        "Febuari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
      ];

      //If no data
      if (data == null || data.length == 0)
        data = [{ period: "No Data", activated: 0, deactivated: 0 }];
      //If filter is CUSTOM
      else if (filter == "CUSTOM") {
        for (var i in data)
          data[i].period = moment(data[i].period).format("DD MMM YY");
      }

      //If filter is DAILY
      else if (filter == "DAILY") {
        for (var i in data) data[i].period = `${data[i].period}:00`;
      }

      //If filter is WEEKLY
      else if (filter == "WEEKLY") {
        for (var i in data)
          data[i].period = moment(data[i].period).format("dddd");
      }

      //If filter is MONTHLY
      else if (filter == "MONTHLY") {
        for (var i in data) data[i].period = `Week ${data[i].period}`;
      }

      //If filter is YEARLY
      else if (filter == "YEARLY") {
        for (var i in data)
          data[i].period = indoMonthNames[
            parseInt(data[i].period) - 1
          ].substring(0, 3);
      }

      console.log("Filter data:", JSON.stringify(data));
      this.chart.addData(data, length);
      // this.chart.addData(this.Data, length);

      // this.chart.addData(this.dummyData && this.dummyData.length > 0 ? this.dummyData : [{period:'No Data', activated:0, deactivated:0}],length);
    },
    createChart() {
      /* Chart code */
      // Themes begin
      am4core.useTheme(am4themes_animated);
      // Themes end

      this.chart = am4core.create(
        this.$refs.activationReportChart,
        am4charts.XYChart
      );

      this.chart.colors.list = [
        am4core.color("#B1E5FD"),
        am4core.color("#FFCDD1"),
      ];

      this.chart.legend = new am4charts.Legend();
      this.chart.legend.position = "bottom";
      this.chart.legend.align = "center";
      this.chart.legend.paddingBottom = 20;
      this.chart.legend.labels.template.maxWidth = 95;

      let xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      xAxis.dataFields.category = "period";
      xAxis.renderer.cellStartLocation = 0.1;
      xAxis.renderer.cellEndLocation = 0.9;
      xAxis.renderer.grid.template.location = 0;

      let yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      yAxis.min = 0;
      yAxis.title.text = "No. of Activities";

      this.chart.cursor = new am4charts.XYCursor();

      this.createSeries("activated", "Activate");
      this.createSeries("deactivated", "Deactivate");
    },
    createSeries(value, name) {
      let series = this.chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = value;
      series.dataFields.categoryX = "period";
      series.name = name;
      series.columns.template.tooltipText =
        "[#fff font-size: 15px]{name} activity in {categoryX}:\n[/][#fff font-size: 20px]{valueY}[/] [#fff]{additional}[/]";
      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;

      // series.events.on("hidden", arrangeColumns);
      // series.events.on("shown", arrangeColumns);

      let bullet = series.bullets.push(new am4charts.LabelBullet());
      bullet.interactionsEnabled = false;
      bullet.dy = 15;
      bullet.label.text = "{valueY}";
      bullet.label.fill = am4core.color("#ffffff");

      return series;
    },
  },
};
</script>

<style scoped></style>
